var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423.17 344.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.4,576.06c159.79,0,247.16-132.41,247.16-247.16,0-3.79,0-7.57-.18-11.17a178.14,178.14,0,0,0,43.42-45,176.19,176.19,0,0,1-49.91,13.69,86.82,86.82,0,0,0,38.2-48.1A176.08,176.08,0,0,1,544,259.36a86.92,86.92,0,0,0-150.24,59.45,79.62,79.62,0,0,0,2.34,19.81A246.44,246.44,0,0,1,217,247.83a86.82,86.82,0,0,0,27,115.83,85.38,85.38,0,0,1-39.27-10.8v1.08a87,87,0,0,0,69.72,85.21,86.68,86.68,0,0,1-22.88,3.06,82.9,82.9,0,0,1-16.39-1.62,86.73,86.73,0,0,0,81.06,60.35,174.59,174.59,0,0,1-107.91,37.11,158,158,0,0,1-20.71-1.26A242,242,0,0,0,320.4,576.06Z",
    transform: "translate(-187.63 -231.98)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSvg);
export default __webpack_public_path__ + "static/media/Twitter_SVG.aa16211e86858af316d5e46ad1ebce53.svg";
export { ForwardRef as ReactComponent };